module.exports = __webpack_public_path__ + "static/media/footer_btn_cancel.0e183771.svg";